import * as React from 'react';
import { Link } from 'react-router-dom';
import train_hosoWLPng from '../images/train_hosoWL.png';

interface Props {
  path: string;
}

const appBar = (props: Props) => {
  const links = [
    {
      title: 'Home',
      url: '/'
    },
    {
      title: 'Tutorial',
      url: '/tutorial'
    }
  ];

  return (
    <div className="hero-head">
      <nav className="navbar">
        <div className="container">
          <div className="navbar-brand">
            <Link className="navbar-item" to="/">
              <img src={train_hosoWLPng} alt="logo" />
            </Link>
          </div>
          <div id="navbarMenuHeroB" className="navbar-menu">
            <div className="navbar-end">
              {links.map((link, index) => {
                return (
                  <Link
                    key={link.title}
                    to={link.url}
                    className={`navbar-item ${
                      link.url === props.path ? 'is-active' : ''
                    }`}
                  >
                    {link.title}
                  </Link>
                );
              })}
              <a
                href="https://github.com/nkgrnkgr/expenses-automation"
                className="navbar-item"
                target="newTab"
              >
                <span className="icon is-medium">
                  <i className="fab fa-github" />
                </span>
                <span>Github</span>
              </a>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default appBar;



// WEBPACK FOOTER //
// ./src/components/AppBar.tsx